export default {
  title: 'Order at {{company}}',
  button: {
    title: "Pay with",
  },
};
